"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactSvg = require("react-svg");

require("./_style.scss");

var _measureTextWidth = _interopRequireDefault(require("../../services/measureTextWidth"));

var _settings = _interopRequireDefault(require("../../settings"));

var _useCloseWhenClickedOutside = _interopRequireDefault(require("../../hooks/useCloseWhenClickedOutside"));

var _DropdownOptionList = _interopRequireDefault(require("./DropdownOptionList"));

var _DropdownSelectedLabel = _interopRequireDefault(require("./DropdownSelectedLabel"));

function Dropdown(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onOptionSelected = _ref.onOptionSelected,
      children = _ref.children,
      rest = _ref.rest;
  var placeholderValue = 'Select Option';

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      selectedValue = _useState4[0],
      setSelectedValue = _useState4[1];

  var dropdownRef = (0, _useCloseWhenClickedOutside["default"])(function () {
    return setIsOpen(false);
  });
  (0, _react.useEffect)(function () {
    setSelectedValue(value);
  }, [value]);

  var toggleOpen = function toggleOpen() {
    setIsOpen(!isOpen);
  };

  var selectOption = function selectOption(option) {
    toggleOpen();
    setSelectedValue(option.value);
    if (onOptionSelected === undefined) return;
    onOptionSelected(option);
  };

  var getLongestPotentialString = function getLongestPotentialString() {
    var longestOption = options.reduce(function (a, _ref2) {
      var value = _ref2.value;
      return a.length > "".concat(value).length ? a : "".concat(value);
    }, '');

    if (value === undefined) {
      longestOption = placeholderValue.length > longestOption.length ? placeholderValue : longestOption;
    }

    return longestOption;
  };

  var calculateDropdownWidth = function calculateDropdownWidth() {
    var longestOption = getLongestPotentialString();
    var longestOptionLength = longestOption.length;
    var arrowSize = 16,
        borderWidth = 4,
        padding = 21.5;
    var letterSpacing = longestOptionLength * 2 * 0.2;
    var additionalSpace = padding + borderWidth + letterSpacing + arrowSize;
    var width = "".concat((0, _measureTextWidth["default"])(longestOption, undefined, '16px') + additionalSpace, "px");
    return {
      width: width
    };
  };

  return /*#__PURE__*/_react["default"].createElement("div", Object.assign({
    className: "nstyle-dd-dropdown ".concat(isOpen ? 'nstyle-dd-dropdown--open' : ''),
    onClick: toggleOpen,
    ref: dropdownRef,
    style: calculateDropdownWidth()
  }, rest), /*#__PURE__*/_react["default"].createElement(_DropdownSelectedLabel["default"], {
    selectedValue: selectedValue,
    placeholder: placeholderValue
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "nstyle-dd__arrow"
  }, /*#__PURE__*/_react["default"].createElement(_reactSvg.ReactSVG, {
    src: _settings["default"].icons.caretDown,
    className: "nstyle-dd__icon"
  })), /*#__PURE__*/_react["default"].createElement(_DropdownOptionList["default"], {
    options: options,
    width: calculateDropdownWidth(),
    selectOption: selectOption,
    isOpen: isOpen
  }), children);
}

var _default = Dropdown;
exports["default"] = _default;